import api from './api';

export function findAll() {
  return api.get('/doencas');
}
